import {
  Google as GoogleIcon,
  Apple as AppleIcon,
} from '@mui/icons-material'
import { Box, Button, Typography } from '@mui/material'
import React from 'react'

type Props = {
  onGooglePress: () => void
  onApplePress: () => void
}

const SocialButtons = (props: Props) => {
  const { onApplePress, onGooglePress } = props
  return (
    <Box display="flex" flexDirection="column" alignItems="center" mb={5}>
      <Typography my={3} fontWeight={600}>Or sign in with:</Typography>
      <Box display="flex" gap={5}>
        <Button
          variant="contained"
          color="error"
          sx={{
            padding: "10px",
            minWidth: "30px"
          }}
          onClick={onGooglePress}
        >
          <GoogleIcon />
        </Button>
        <Button
          variant="contained"
          color="secondary"
          sx={{
            padding: "10px",
            minWidth: "30px"
          }}
          onClick={onApplePress}
        >
          <AppleIcon />
        </Button>
      </Box>
    </Box>
  )
}

export default SocialButtons